module.exports = __webpack_public_path__ + "img/logo9.a4c764cd.png";